import { useCallback } from 'react'
import { IconButton, DialogContent, DialogActions, Button } from '@mui/material'
import Dialog from '@derolfgroep/ui-components/src/components/Dialog/Dialog'
import DialogTitleClose from '@derolfgroep/ui-components/src/components/Dialog/DialogTitleClose'
import InstitutionSelectorAutocomplete from './InstitutionSelectorAutocomplete'
import PropTypes from 'prop-types'
import { creatorUseToggle } from '@derolfgroep/utils/lib/react/simpleStateManager/simpleStateManager'
import { resetField } from 'react-bfm/lib/field/actions'
import { Institution } from '../../icons/appbar'

const useToggleDialog = creatorUseToggle()

const InstitutionSelectorMobile = ({ options, defaultValue, onSelectInstitution }) => {
  const { isOpen, handleOpen, handleClose } = useToggleDialog()

  const handleCancelSelection = useCallback(() => {
    resetField('institutionSelector', 'institution')
    handleClose()
  }, [handleClose])
  const handleInstitutionSelection = useCallback(() => {
    if (onSelectInstitution) {
      onSelectInstitution()
    }
    handleClose()
  }, [handleClose, onSelectInstitution])

  return (
    <>
      <IconButton
        aria-haspopup="true"
        onClick={handleOpen}
        aria-label="Selecteer school"
        size="large"
        data-analytics="institutionSelectorMobileToggle"
      >
        <Institution />
      </IconButton>
      <Dialog
        open={isOpen}
        onClose={handleCancelSelection}
        aria-labelledby="dialog-title-school-selection"
        aria-describedby="dialog-description-school-selection"
        data-analytics="dialogInstitutionSelectorMobile"
      >
        <DialogTitleClose
          id="dialog-title-school-selection"
          onClose={handleCancelSelection}
          component="h2"
          variant="h4"
        >
          Selecteer school
        </DialogTitleClose>
        <DialogContent id="dialog-description-school-selection" style={{ overflow: 'hidden' }}>
          <InstitutionSelectorAutocomplete options={options} defaultValue={defaultValue} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelSelection} data-analytics="institutionSelectorMobileButtonCancel">
            Annuleren
          </Button>
          <Button
            onClick={handleInstitutionSelection}
            variant="contained"
            color="primary"
            data-analytics="institutionSelectorMobileButtonConfirm"
          >
            Bevestigen
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
InstitutionSelectorMobile.propTypes = {
  options: PropTypes.any,
  defaultValue: PropTypes.any,
  onSelectInstitution: PropTypes.func,
}

export default InstitutionSelectorMobile
